import { Link } from "react-router-dom";
import { BRAND, NAV_LINKS, SERVICES } from "../data/content";
import NewsletterForm from "./sections/NewsletterForm";

export default function Footer() {
    const year = new Date().getFullYear();

    return (
        <footer
            className="relative border-t border-[rgba(201,168,106,0.15)] bg-[#0B0B0C] text-[#F3EFE7] overflow-hidden"
            data-testid="site-footer"
        >
            <div className="shell py-20 md:py-24">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-14">
                    {/* Brand blurb */}
                    <div className="lg:col-span-4">
                        <div className="flex items-center gap-3 mb-6">
                            <span className="font-serif text-[22px] text-[#C9A86A] tracking-[0.4em]">
                                ACT
                            </span>
                            <span className="h-4 w-px bg-[rgba(201,168,106,0.35)]" />
                            <span className="text-[10.5px] font-medium text-[#F3EFE7] tracking-[0.32em] uppercase">
                                Advanced Connected Technologies
                            </span>
                        </div>
                        <p className="max-w-sm text-[#9A958A] text-sm leading-[1.9]">
                            Bespoke smart-home integration for principal
                            residences. Concierge-tier design, certified
                            delivery, and a lifetime of stewardship — authored
                            in partnership with the world&rsquo;s most
                            discreet architects and interior studios.
                        </p>

                        <div className="mt-12">
                            <NewsletterForm />
                        </div>
                    </div>

                    {/* Services */}
                    <div className="lg:col-span-3">
                        <div className="eyebrow mb-6">Services</div>
                        <ul className="space-y-3">
                            {SERVICES.map((s) => (
                                <li key={s.slug}>
                                    <Link
                                        to={`/services/${s.slug}`}
                                        className="text-sm text-[#F3EFE7] hover:text-[#C9A86A] transition-colors duration-300"
                                        data-testid={`footer-service-${s.slug}`}
                                    >
                                        {s.name}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Company */}
                    <div className="lg:col-span-2">
                        <div className="eyebrow mb-6">Company</div>
                        <ul className="space-y-3">
                            {NAV_LINKS.filter(
                                (n) => n.to !== "/services",
                            ).map((n) => (
                                <li key={n.to}>
                                    <Link
                                        to={n.to}
                                        className="text-sm text-[#F3EFE7] hover:text-[#C9A86A] transition-colors duration-300"
                                        data-testid={`footer-link-${n.label.toLowerCase()}`}
                                    >
                                        {n.label}
                                    </Link>
                                </li>
                            ))}
                            <li>
                                <Link
                                    to="/reviews"
                                    className="text-sm text-[#F3EFE7] hover:text-[#C9A86A] transition-colors duration-300"
                                    data-testid="footer-reviews-link"
                                >
                                    Reviews
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* Contact */}
                    <div className="lg:col-span-3">
                        <div className="eyebrow mb-6">Contact</div>
                        <ul className="space-y-3 text-sm">
                            <li>
                                <a
                                    href={BRAND.phoneHref}
                                    className="text-[#F3EFE7] hover:text-[#C9A86A] transition-colors duration-300 whitespace-nowrap"
                                    data-testid="footer-phone"
                                >
                                    {BRAND.phone}
                                </a>
                            </li>
                            <li>
                                <a
                                    href={BRAND.emailHref}
                                    className="inline-block max-w-full text-[13px] md:text-sm text-[#F3EFE7] hover:text-[#C9A86A] transition-colors duration-300 break-keep [overflow-wrap:normal]"
                                    data-testid="footer-email"
                                >
                                    {BRAND.email}
                                </a>
                            </li>
                            <li className="pt-2 text-[#9A958A] leading-[1.9]">
                                {BRAND.region}
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-20 hairline-solid" />

                <div
                    className="mt-8 flex flex-wrap items-center gap-x-3 gap-y-2 text-[11px] tracking-[0.25em] uppercase text-[#9A958A]"
                    data-testid="footer-bottom-row"
                >
                    <span>© {year} Advanced Connected Technologies</span>
                    <span
                        aria-hidden="true"
                        className="text-[rgba(201,168,106,0.45)] select-none"
                    >
                        ·
                    </span>
                    <span>All rights reserved</span>
                    <span
                        aria-hidden="true"
                        className="text-[rgba(201,168,106,0.45)] select-none"
                    >
                        ·
                    </span>
                    <Link
                        to="/private/access"
                        className="text-[rgba(201,168,106,0.7)] hover:text-[#C9A86A] transition-colors duration-300"
                        data-testid="footer-private-portfolio"
                    >
                        Private Portfolio
                    </Link>
                    <span
                        aria-hidden="true"
                        className="text-[rgba(201,168,106,0.45)] select-none"
                    >
                        ·
                    </span>
                    <Link
                        to="/concierge/login"
                        title="Concierge sign-in"
                        rel="nofollow"
                        data-noindex="true"
                        className="text-[rgba(201,168,106,0.7)] hover:text-[#C9A86A] transition-colors duration-300"
                        data-testid="footer-concierge"
                    >
                        Concierge
                    </Link>
                </div>
            </div>
        </footer>
    );
}
